import React from "react";

import TableCustom from "./AllProductsTable";

const StoreProductsAnalysis = ({ store, marketplace }) => {
  let params = {};
  params["periodicity"] = "day";
  params["store"] = store;
  params["marketplace"] = marketplace;
  let current = {};
  const formatLocalDate = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
      d.getDate()
    ).padStart(2, "0")}`;
  let nowDate = new Date();
  current["end_date"] = formatLocalDate(nowDate);
  current["start_date"] = formatLocalDate(
    new Date(nowDate.getFullYear(), nowDate.getMonth() - 1, 1)
  );

  params["compareConditions"] = { current: current };

  return <TableCustom value={params} />;
};

export default StoreProductsAnalysis;
